import dayjs from 'dayjs';

import { INewSigningCardFooterProps } from '.';

// Required state from ITeamMember
export interface ICalcNewSigningFooterArgs {
  eventStartTime: number;
  eventParticipants: { participantCode: string }[];
}

export const calcNewSigningFooterProps = ({ eventStartTime, eventParticipants }: ICalcNewSigningFooterArgs): INewSigningCardFooterProps => {
  const startTime = dayjs(eventStartTime).format('MMM D, hA');

  return {
    homeTeamCode: eventParticipants[0]?.participantCode ?? '',
    awayTeamCode: eventParticipants[1]?.participantCode ?? '',
    startTime
  };
};
